import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import usePageTitle from '../../hooks/usePageTitle';
import { SignaturesList } from '../../components/SignaturesList';
import { SignaturesGraph } from '../../components/SignaturesGraph';
import Analytics from '../../components/Analytics';
import useLocalizedCopy from '../../hooks/useLocalizedCopy';

export const CONTAINER_CONTENT_CLASS = "flex flex-wrap items-center lg:items-end justify-between pb-5"

export function Signatures() {

    const { copy } = useLocalizedCopy();

    usePageTitle(copy.Services.signatures.title);

    const [viewingTab, setViewingTab] = useState<'list' | 'graph' | 'analytics'>('list');

    return <>
        <div className="container-fixed">
            <div className={CONTAINER_CONTENT_CLASS}>
                <div className="flex flex-col justify-center gap-2">
                    <div className="flex items-center gap-2">
                        <button
                            type="button"
                            className={`btn ${viewingTab === 'list' ? 'btn-primary' : 'btn-light'}`}
                            onClick={() => setViewingTab('list')}
                        >
                            List
                        </button>
                        <button
                            type="button"
                            className={`btn ${viewingTab === 'graph' ? 'btn-primary' : 'btn-light'}`}
                            onClick={() => setViewingTab('graph')}
                        >
                            Dashboard
                        </button>
                        <button
                            type="button"
                            className={`btn ${viewingTab === 'analytics' ? 'btn-primary' : 'btn-light'}`}
                            onClick={() => setViewingTab('analytics')}
                        >
                            Analytics
                        </button>
                    </div>
                </div>
                <div className="flex items-center gap-2.5">
                    {false && <Link className="btn btn-sm btn-light" to="/create-service">
                        {copy.CreateService.title}
                    </Link>}
                </div>
            </div>
        </div>
        <div className="container-fixed">
            {viewingTab === 'list' ? <SignaturesList /> : viewingTab === 'graph' ? <SignaturesGraph /> : <Analytics />}
        </div>
    </>
}